import * as t from 'ts-schema';
import { defineMessage } from 'magpie-lib/models';
const bookmarkSchema = t.object({
  path: t.string
});
const bookmarkChanged = defineMessage({
  type: 'bookmark-changed',
  payloadSchema: t.object({
    success: t.boolean,
    bookmark: bookmarkSchema,
    failureReason: t.optional(t.string)
  })
});
const addBookmark = defineMessage({
  type: 'add-bookmark',
  payloadSchema: bookmarkSchema,
  reply: bookmarkChanged
});
const removeBookmark = defineMessage({
  type: 'remove-bookmark',
  payloadSchema: bookmarkSchema,
  reply: bookmarkChanged
});
const currentBookmarks = defineMessage({
  type: 'current-bookmarks',
  payloadSchema: t.array(bookmarkSchema)
});
const getCurrentBookmarks = defineMessage({
  type: 'get-current-bookmarks',
  reply: currentBookmarks
});
export const bookmarksApi = {
  addBookmark,
  removeBookmark,
  getCurrentBookmarks,
  currentBookmarks,
  bookmarkChanged
};